// extracted by mini-css-extract-plugin
export var menuIcon = "_lb-0";
export var menuIconInline = "_lb-1";